<template>
  <el-drawer
    :title="title"
    :visible.sync="drawer"
    :with-header="true"
    size="30%"
    :before-close="handleOpenDrawer"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-form
            :label-position="labelPosition"
            label-width="100px"
            size="mini"
          >
            <!-- <el-form-item label="Id">
              <el-input></el-input>
            </el-form-item> -->
            <el-form-item label="Nombre">
              <el-input v-model="items.FullName"></el-input>
            </el-form-item>
            <el-form-item label="Telefono">
              <el-input v-model="items.PhoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="Correo">
              <el-input v-model="items.Email"></el-input>
            </el-form-item>
            <el-form-item label="Origen">
              <el-input v-model="items.From"></el-input>
            </el-form-item>
            <el-form-item label="Asunto">
              <el-input v-model="items.Subjet"></el-input>
            </el-form-item>
            <el-form-item label="Comentario">
              <el-input
                v-model="items.Comment"
                type="textarea"
                :rows="5"
                placeholder="Please input"
              ></el-input>
            </el-form-item>
            <el-form-item label="Fecha Creación">
              <el-input v-model="items.CreatedAt"></el-input>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <el-button
            type="primary"
            size="mini"
            :loading="false"
            v-on:click="navigateToProspect"
          >
            Procesar</el-button
          >
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>
<script>
import { formatMonto } from "@/utils";

export default {
  name: "LeadsDetails",
  props: {
    FullName: {
      type: String
    }
  },
  components: {},
  data() {
    return {
      items: [],
      labelPosition: "top",
      title: "Detalle de Oportunidades",
      drawer: false,
      loading: false
    };
  },
  computed: {},
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    show(props) {
      this.items = props;
      this.drawer = true;
    },
    navigateToProspect() {
      this.$router.push({
        path: "../call-center/prospects/create",
        query: {
          PhoneNumber: this.items.PhoneNumber,
          Company: this.items.Company,
          FirstName: this.items.FullName,
          Email: this.items.Email,
          No: this.items.Id
        }
      });
    },
    handleOpenDrawer(done) {
      done();
    }
  }
};
</script>

<style></style>
